import script from "./OpenGameCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenGameCard.vue?vue&type=script&setup=true&lang=js"

import "./OpenGameCard.vue?vue&type=style&index=0&id=22c22be1&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22c22be1"]])

export default __exports__